import { SET_CENTRO_DIA, INVALIDATE_CENTRO_DIA, ENABLE_CENTRO_DIA } from '../constants/action_types';
import { getData } from './redux_data';

export function setCentroDia(centro, dia, semanal, fromUI = false) {

    let URL = 'centroDia?centro_id=' + centro + '&semanal=' + semanal;
    if (dia !== undefined) URL += '&date=' + dia;

    return getData(URL, SET_CENTRO_DIA, { centro, dia, fromUI });
}

export function invalidateCentroDiaData() {
    return (dispatch, getState) => {
        dispatch({ type: INVALIDATE_CENTRO_DIA });
    }
}

export function enableCentroDiaData() {
    return (dispatch, getState) => {
        dispatch({ type: ENABLE_CENTRO_DIA });
    }
}